<template>
  <div>
    <div class="divButtonRigth">
      <el-input v-model="listQuery.content" placeholder="请输入搜索内容"></el-input>
      <el-button type="primary"  size="small" @click="queryLike">查询</el-button>
      <el-button type="primary"  size="small" @click="readMsg">标记已读</el-button>
      <el-button type="primary"  size="small" @click="deleteMsg">删除</el-button>
    </div>
    <div style="margin-bottom: 20px">
      <el-checkbox v-model="checked" size="small" @change="unread(checked)">仅看未读消息</el-checkbox>
    </div>
    <bsp-table :data.sync="list" ref="msgTable"
               show-header-overflow
               show-overflow
               v-loading="loading"
               element-loading-text="拼命加载中"
               element-loading-spinner="el-icon-loading"
               :ciic-data-filter.sync="listQuery"
               @ciic-data-select="_getselect"
               @ciic-data-refresh="_getdynamicList">
      <vxe-table-column
        fixed="left"
        type="selection"
        width="60"
      />
     <!-- <vxe-table-column
        fixed="left"
        type="index"
        title="序号"
        width="60"
      />-->
      <bsp-table-column
        field="msgContent"
        title="内容"
        align="left"
      >
        <template slot-scope="scope" >
          <el-link type="primary" icon="el-icon-info" style="color: #E6A23C" v-if="scope.row.isRead=='00900'"></el-link>
          <span>{{ scope.row.msgContent }}</span>
        </template>
      </bsp-table-column>
     <!-- <bsp-table-column
        field="msgType"
        title="消息类型"
        align="left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.type | dictFilter(msgTypes) }}</span>
        </template>
      </bsp-table-column>-->
      <bsp-table-column
        field="cusName"
        title="时间"
        align="left"
        width="150"
      >
      <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </bsp-table-column>
    </bsp-table>
  </div>
</template>

<script>
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import {queryListPageByType,updateBatchHrcloudMsgStatus,deletBatchMsg,queryMsgList } from  "@/api/msg/msg"
  import { mapGetters } from 'vuex';
  export default {
    name: "table",
    components: {bspTableColumn, bspTable},
    props: {
      currentTab: {
        type: String,
        default: ''
      },
    },
    created(){
      this._getdynamicList();
    },
    mounted() {
    },
    computed: {
      ...mapGetters([
        'dicts',
        'memberInfo'
      ]),
    },
    watch: {
      currentTab: function (newVal, oldVal) {
        //this.listQuery.tabType = newVal;
        console.log(newVal+"============");
        this.listQuery.type = newVal;
        this._getdynamicList();
      }
    },
    data(){
      return{
        checked: false,
        list:[],
        selectList:[],
        selectIds:[],
        del:{ids:[12,13]},
        updateStatus:{
           ids: [],
           status: 23
        },
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          isSort:true,// 是否加序号列
          status:'',// 消息状态 00901已读  00900未读
          content:'',// 消息内容
          type:0// 消息类型
        },
        msgTypes: {
          "30420009":"系统消息",
          "30420007":'休假消息',
          "30420008":'考勤消息',
          "30420005":'其他消息',
        },
      }
    },
    filters: {
    },
    methods: {
      getMsgTypeName(type) {
        console.log("翻译消息类型",type);
        return this.msgTypes[type];
      },

      //获取列表数据
      _getdynamicList() {
        this.listQuery.type = this.currentTab;
        this.loading = true;
        queryMsgList(this.listQuery).then(res => {
          var data = res.data.data;
          this.showTable = true
          this.listQuery.total = data.total
          this.list = data.records;
          this.loading = false;
        }).catch(() => {
          this.loading = false
        })
      },
      /**
       * 查询未读消息
       */
      unread(value){
        if(value){
          this.listQuery.status='00900';
          this._getdynamicList();
        }else {
          this.listQuery.status='';
          this._getdynamicList();
        }
      },
      /**
       * 模糊搜索
       */
      queryLike(){
        console.log("标记已读");
        this._getdynamicList();
      },
      /**
       * 标记已读
       */
      readMsg(){
        if(this.selectList.length<1){
          this.$message.warning('请至少选择一条数据');
          return false;
        }
        this.$confirm('确定标记为已读？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateBatchHrcloudMsgStatus({ids:this.selectIds,isRead:'00901'}).then(res=>{
              this.$message.success('操作成功');
              this._getdynamicList();
          })
        })

      },
      /**
       * 删除消息
       */
      deleteMsg(){
        if(this.selectIds.length<1){
          this.$message.warning('请至少选择一条数据');
          return false;
        }
        this.$confirm('确定删除数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateBatchHrcloudMsgStatus({ids:this.selectIds,isDelete:'00901'}).then(res => {
              this.$message.success('删除成功');
              this._getdynamicList();
          })
        })
      },
      /**
       *全选
       * @param checked
       * @param selection
       */
      getSelectAll({checked, row}) {
        let selects = this.$refs.msgTable.getSelectRecords();
        this.selectList = selects;
        console.log("选择",selects)
      },
      /**
       * 勾选
       * @param checked
       * @param row
       */
      _getselect(selects) {
        console.log("选择",selects);
        this.selectList = selects;
        this.selectIds =[];
        selects.forEach(item=>{
          this.selectIds.push(item.id);
          console.log("选择的id4444",item.id);
        })
        console.log("选择的id",this.selectIds);
      },


    },

  }
</script>

<style scoped>

</style>
